import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GerinusService } from '../lib/gerinus.service';

@Injectable({
    providedIn: 'root',
})  
export class DepartmentService extends GerinusService {
    constructor(public http: HttpClient) {
        super(http);
        this.entityName = 'departamento';
        this.idField = 'DEP_CodigoDepartamento';
        this.model = 'DepartamentoModel';
    }

    public generateListReportPDF(title: string, condition: string) {
        const formData = new FormData();
        formData.append('title', title);
        formData.append('condition', condition);

        return this.http.post(
            this.apiURL() + '/api/pdf/department-report-list', 
            formData, 
            { 
                ...this.headers(true), 
                responseType: 'blob', 
                reportProgress: true, 
                observe: 'events' 
            }
        );
    }
}
